import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IdArticle, SponsoredArticlesResponse, UrlArticle } from 'src/app/models/sponsored-content';
import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SponsoredContentService {
  private baseUrl = `${env.apiCerberoUrl}`;

  constructor(private http: HttpClient) { }


  getArticlesSponsored(): Observable<SponsoredArticlesResponse>{
    return this.http.get<SponsoredArticlesResponse>(`${this.baseUrl}/request?event=articulos-patrocinados`);
  }

  createArticle(url: UrlArticle): Observable<UrlArticle> {
    return this.http.post<UrlArticle>(`${this.baseUrl}/request?event=agregar-articulo-patrocinado`, url);
  }

  deleteArticle(id: IdArticle): Observable<IdArticle> {
    return this.http.post<IdArticle>(`${this.baseUrl}/request?event=quitar-articulo-patrocinado`, id);
  }

}
